export const DEFAULT_LANG = 'en';
export const I18N_TO_DEFAULT_LANG = [{
  lang: 'pt',
  locale: 'pt-br',
  defaultLang: 'pt-br'
}, {
  lang: 'zh',
  locale: 'zh-tw',
  defaultLang: 'zh-tw'
}, {
  lang: 'es',
  locale: 'es-ar',
  defaultLang: 'es'
}, {
  lang: 'es',
  locale: 'es-mx',
  defaultLang: 'es-mx'
}, {
  lang: 'fr',
  locale: 'fr-ca',
  defaultLang: 'fr-ca'
}];